import { RequestStatus } from 'clickNgo/configs/service/common'

import { ICompletenessState } from './models/state'

export const initialState: ICompletenessState = {
  data: [],
  pendingSnapshotRequests: {},
  status: RequestStatus.FULFILLED,
  message: '',
}
